import React from "react";

const TituloPrincipal = ({ textoInicial = "", texto = "" }) => {
  return (
    <>
      <div className="d-flex flex-row gap-2">
        {textoInicial && <h3 className="mt-4 pb-0 mb-0">{textoInicial}</h3>}
        <h3 className="mt-3 fontTitulo pb-0 mb-0">{texto}</h3>
      </div>
      <div className="title-underline bg-perfil-medium"></div>
    </>
  );
};

export default TituloPrincipal;

/************** IMPORTANTE **************
 USO DEL COMPONENTE:

 Descripción: `TituloPrincipal` es un componente de título que muestra un título principal con una opción para incluir un texto inicial. Está diseñado para ser utilizado como encabezado de sección o título destacado en una interfaz de usuario.

 Props:
 - `textoInicial` (String): Texto opcional que se muestra antes del `texto`. Si no se proporciona, esta parte no se renderiza. Por defecto es una cadena vacía.
 - `texto` (String): Texto principal que se mostrará en el componente. Este texto es obligatorio y se renderiza siempre.

 Ejemplo de Uso:
 Aquí se muestra cómo implementar el componente `TituloPrincipal` con un texto inicial y un texto principal.

       <TituloPrincipal
        textoInicial="Subtítulo"
        texto="Título Principal"
       />

 Variantes:
 - Si se proporciona `textoInicial`, este se mostrará en una línea antes del `texto`. De lo contrario, solo se mostrará el `texto`.
 - El componente incluye una línea de subrayado (una barra) debajo del título, que se estiliza con la clase `bg-perfil-medium`.

*****************************************/
